export default __webpack_public_path__ + "static/media/My_car_website_images-9_10.9a5bad40.webp";